import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { INotification } from '../event-store/interfaces/event.interface';

export const NotificationActions = createActionGroup({
  source: 'Notification',
  events: {
    'Load Notifications': emptyProps(),
    'Load Notifications Success': props<{ notifications: INotification[] }>(),
    'Load Notifications Failure': props<{ error: unknown }>(),

    /** Begins the periodic refresh that keeps the header badge honest. */
    'Start Polling': emptyProps(),
    'Stop Polling': emptyProps(),

    'Mark Read': props<{ id: number }>(),
    'Mark Read Success': props<{ notification: INotification }>(),
    'Mark Read Failure': props<{ error: unknown }>(),

    'Mark All Read': emptyProps(),
    // The timestamp travels in the payload so the reducer stays pure and testable; the endpoint
    // only answers with a count, not the updated rows.
    'Mark All Read Success': props<{ readAt: string }>(),
    'Mark All Read Failure': props<{ error: unknown }>(),
  },
});
